import { initializeApp } from "firebase/app"
import { getAnalytics, setAnalyticsCollectionEnabled } from "firebase/analytics"
import { getAuth } from "firebase/auth"
import { getFirestore } from "firebase/firestore"
import { getStorage } from "firebase/storage"

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDorWUi-A_LY9qsm01VMXHyYWnmZZ5R3QE",
  authDomain: "express-payment-services.firebaseapp.com",
  projectId: "express-payment-services",
  storageBucket: "express-payment-services.appspot.com",
  messagingSenderId: "341273970064",
  appId: "1:341273970064:web:8bbbb2f57334e0bfe35f15",
  measurementId: "G-72V7D57HSZ"
};

// const url = process.env.NODE_ENV !== 'production' ? 'http://localhost:3000/' : firebaseConfig.authDomain

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig)
const hosting = firebaseConfig.authDomain

// module
const analytics = getAnalytics(firebaseApp)
const storage = getStorage(firebaseApp)
const db = getFirestore()
const auth = getAuth()

if (window.location.hostname === "localhost") {
  setAnalyticsCollectionEnabled(analytics, false)
}

// Firebase previously initialized using firebase.initializeApp().
// if (window.location.hostname === "localhost") {
//   db.useEmulator("localhost", 8080)
//   auth.useEmulator("http://localhost:9099")
//   functions.useEmulator("localhost", 5001)
// }

export {
  auth,
  db,
  firebaseConfig,
  hosting,
  storage
}

// https://firebase.google.com/docs/firestore/use-rest-api
// https://firestore.googleapis.com/v1/projects/mastercard-black-rhr/databases/(default)/documents/properties1
